import {useQuery} from '@tanstack/react-query';
import {API, GuestTokenStorageHandler} from '@chekin/api';
import {QUERY_CACHE_KEYS} from '@chekin/core';

type Props = {
  enabled?: boolean;
};
function useFetchUser({enabled}: Props = {enabled: true}) {
  const guestToken = GuestTokenStorageHandler.getToken();

  return useQuery({
    queryKey: [QUERY_CACHE_KEYS.user, guestToken],
    queryFn: () => API.auth.getMe(),
    enabled: Boolean(enabled && guestToken),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
}

export {useFetchUser};
